// ============================================================
// PROTECTED ROUTE
// ============================================================

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Only redirect once, as a side effect — never during render (prevents replaceState loop)
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      // Guard: don't redirect if already on login page (prevents infinite loop)
      if (!window.location.pathname.includes('/admin/login')) {
        navigate('/admin/login', { replace: true, state: { from: location } });
      }
    }
  }, [loading, isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#0F172A',
      }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <div style={{
            width: 48, height: 48, border: '3px solid rgba(232,93,4,0.3)',
            borderTopColor: '#E85D04', borderRadius: '50%',
            animation: 'admin-spin 0.8s linear infinite',
            margin: '0 auto 16px',
          }} />
          <p style={{ color: '#94A3B8', fontSize: 14 }}>Loading admin panel...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return children;
};

export default ProtectedRoute;
